<template>

    <v-content>
        <v-container fluid>

            <panelcontainer>
                <div class="headline" slot="headline">Reçete / Wetend</div>
                <div slot="actions">
					<actions v-if="getAuth.isAdmin" module="recipes_wetend" :item="item" />
                    <v-btn tile color="indigo" dark @click="saveItem()">
                        <v-icon>{{mdiContentSave}}</v-icon> Kaydet
                    </v-btn>
                </div>
                <loading v-if="isLoading" text="Ürün listesi yükleniyor..." size="80" width="2" />

                <template v-if="!isLoading">
                    <v-container grid-list-md mt-3>
                        <v-layout wrap> 
                            <v-flex xs6 mb-3>
                                <v-text-field label="Konu" v-model="item.title" outlined hide-details placeholder="Örn: Burnish Mutation"></v-text-field>
                            </v-flex>
                            <v-flex xs3 mb-3>
                                <v-select v-model="item.user_id" :items="users" item-value="id" item-text="fullname" label="Müşteri Adı" outlined hide-details></v-select>
                            </v-flex>
                            <v-flex xs6 md3 mb-3>
                                <datepicker label="Tarih"  v-model="item.date_text" locale="tr-tr"/>
                            </v-flex>
                        </v-layout>
                    </v-container>


                    <v-container grid-list-md mt-3>
                        <v-layout wrap>
                            <v-flex xs12>
                                <table class="RecipesTable RecipesTableWetend">
                                    <tbody>
										<tr class="tblInfo">
											<td align="right" valign="middle" colspan="2" class="tdlLabel">Deneme No:</td>
											<td colspan="3"><input class="recipesInputtext" type="text" v-model="item.deneme_no"></td>
											<td align="right" valign="middle" colspan="2" class="tdlLabel">Dolap No:</td>
											<td colspan="5"><input class="recipesInputtext" type="text" v-model="item.dolap_no"></td>
										</tr>
										<tr class="tblInfo">
											<td align="right" valign="middle" colspan="2" class="tdlLabel">Deri Tipi:</td>
											<td colspan="3"><input class="recipesInputtext" type="text" v-model="item.deri_tipi"></td>
											<td align="right" valign="middle" colspan="2" class="tdlLabel">Kalınlık:</td>
											<td colspan="5"><input class="recipesInputtext" type="text" v-model="item.kalinlik"></td>
										</tr>
										<tr class="tblInfo">
											<td align="right" valign="middle" colspan="2" class="tdlLabel">Renk:</td>
											<td colspan="3"><input class="recipesInputtext" type="text" v-model="item.color"></td>
											<td align="right" valign="middle" colspan="2" class="tdlLabel">Ağırlık:</td>
											<td colspan="5"><input class="recipesInputtext" type="text" v-model="item.agirlik" @input="calcMiktarAll()"></td>
										</tr>
										<tr class="tblInfo">
											<td align="right" valign="middle" colspan="2" class="tdlLabel">Yöre:</td>
											<td colspan="3"><input class="recipesInputtext" type="text" v-model="item.yore"></td>
											<td align="right" valign="middle" colspan="2" class="tdlLabel">Adet:</td>
											<td colspan="5"><input class="recipesInputtext" type="text" v-model="item.adet"></td>
										</tr>
										<tr class="tblInfo">
											<td align="right" valign="middle" colspan="2" class="tdlLabel">Ürün Adı:</td>
											<td colspan="3"><input class="recipesInputtext" type="text" v-model="item.product_name"></td>
											<td align="right" valign="middle" colspan="2" class="tdlLabel"></td>
											<td colspan="5"></td>
										</tr>
                                        <tr class="tblHeads">
                                            <td width="150px">
												<b>İşlem</b>
											</td>
                                            <td width="50px">
												<b>Yüzde</b> <b>%</b>
											</td>
                                            <td width="80px">
												<b>Miktar</b> <b>(Gram)</b>
											</td>
                                            <td >
												<b>Ürün Adı</b>
											</td>
                                            <td width="50px">
												<b>Sıc</b> <b>(&#176;C)</b>
											</td>
                                            <td width="50px">
												<b>Zaman</b> <b>( dk )</b>
											</td>
                                            <td width="50px">
												<b>Devir</b>
											</td>
                                            <td colspan="3">
												<b>Notlar</b>
											</td> 
                                        </tr> 
                                        <tr v-for="(entry,entryIndex) in item.entries" :key="'itemEntry'+entryIndex" class="entryItem">
                                            <td>
												<input class="recipesInputtext" type="text" v-model="entry.islem">
											</td>
                                            <td>
												<input class="recipesInputnumber" type="text" v-model="entry.yuzde" @input="calcMiktar(entryIndex)">
											</td>
                                            <td>
												<input class="recipesInputnumber" type="text" v-model="entry.miktar">
											</td>
                                            <td>
												<input class="recipesInputtext" type="text" v-model="entry.product_name">
											</td>
                                            <td>
												<input class="recipesInputnumber" type="text" v-model="entry.sic">
											</td>
                                            <td>
												<input class="recipesInputnumber" type="text" v-model="entry.zaman">
											</td>
                                            <td>
												<input class="recipesInputnumber" type="text" v-model="entry.devir">
											</td>
                                            <td>
												<input class="recipesInputtext" type="text" v-model="entry.notlar">
											</td> 
											<td class="actions">
												<v-btn small tile icon color="primary" dark @click="addEntry(entryIndex)">
													<v-icon>{{mdiTableRowPlusBefore}}</v-icon>
												</v-btn>
											</td>
											<td class="actions">
												<v-btn small tile icon color="red" dark v-on:click.stop.prevent="removeEntry(entryIndex)">
													<v-icon>{{mdiCloseCircle}}</v-icon>
												</v-btn>
											</td>
                                        </tr>
                                        <tr>
											<td align="center" valign="middle" colspan="10" height="40px">
												<v-btn tile small color="green" dark @click="addEntry()"> Yeni Satır Ekle </v-btn>
											</td>
										</tr>
                                        <tr class="tblTotal">
                                            <td colspan="5"></td>
                                            <td align="center" valign="middle">
												{{getTotals.zaman}}
											</td>
                                            <td colspan="4" >
												<b>Toplam İşlem Zamanı</b>
											</td> 
                                        </tr>
                                        <tr class="tblMechanic">
                                            <td align="right" valign="middle" colspan="2">
												<b>Mekanik İşlem:</b>
											</td>
                                            <td colspan="8">
												<input class="recipesInputtext" type="text" v-model="item.mekanik_islem">
											</td>
                                        </tr>
                                    </tbody>

                                </table>
                            </v-flex>
                        </v-layout>
                    </v-container>

 
                </template>
            </panelcontainer>

    <v-snackbar
      v-model="actionDialogShow" 
      :color="actionDialogColor"   
      :timeout="3000"
      top 
    >
      {{ actionDialogText }}
      <v-btn
        dark
        text
        @click="actionDialogShow = false"
      >
        Tamam
      </v-btn>
    </v-snackbar>

        </v-container>
    </v-content>


</template>
 

<script>
    import loading from "@/components/utils/loading"
    import panelcontainer from "@/components/utils/panelcontainer"
    import inputtffloat from "@/components/inputs/tffloat"
    import datepicker from "@/components/inputs/datepicker" 
    import actions from "@/components/utils/actions"
    import {
        mdiPlus,
        mdiCloseCircle,
        mdiBellCheck,
        mdiTimerSand,
        mdiEmailSend,
        mdiCalendarRange,
        mdiTableRowPlusBefore,
        mdiContentSave,
    } from '@mdi/js';
    export default {
        components: {
            loading,
            panelcontainer,
            datepicker, 
            actions, 
        },
        data: () => ({
            mdiPlus: mdiPlus,
            mdiCloseCircle: mdiCloseCircle,
            mdiBellCheck: mdiBellCheck,
            mdiTimerSand: mdiTimerSand,
            mdiEmailSend: mdiEmailSend,
            mdiCalendarRange: mdiCalendarRange,
            mdiTableRowPlusBefore: mdiTableRowPlusBefore,
            mdiContentSave: mdiContentSave,

            isLoading: false,
            dialogEditor: false,
            dialogRemove: false,
            users: [], 
			item: {},
			
			actionDialogShow : false,
			actionDialogText : "",
			actionDialogColor : "",
		}),
		mounted(){
			this.item_id = this.$route.query.id || ""
			this.loadUsers() 
			this.loadItem() 
		},
        methods: {
			loadUsers(){
				this.$http.get( process.env.VUE_APP_API_URL + "/users/shared", {
					params : { }
				}).then(response => {
					this.users = response.body;  
				}) 
			},
			loadItem(){
				this.isLoading = true;
				if(this.item_id == ""){
					this.setNewItemData();
					this.isLoading = false; 
				}else{ 
					this.$http.get( process.env.VUE_APP_API_URL + "/recipes/wetend/info", {
						params : { id : this.item_id }
					}).then(response => {
						this.item = response.body; 
						this.isLoading = false; 
					})  
				}
			},
			setNewItemData(){
				this.item = {
					id:"", 
					title:"", 
					user_id:"", 
					date_text:"", 
					deneme_no:"", 
					dolap_no:"", 
					deri_tipi:"", 
					kalinlik:"", 
					color:"", 
					agirlik:"", 
					yore:"", 
					adet:"", 
					product_name:"", 
					entries: [], 
					totals: [], 
					mekanik_islem : ""
				}
				for(var i = 0;i < 10; i++){
					this.addEntry();
				}
			},
			addEntry(before){
				var entry = {
					islem : "",
					yuzde : "",
					miktar : "",
					product_name : "",
					sic : "",
					zaman : "",
					devir : "",
					notlar : "", 
				}
				if(before === 0 || before > 0){
					this.item.entries.splice(before, 0, entry);
				}
				else{
					this.item.entries.push(entry)
				}
			},
			removeEntry(i){
				this.item.entries.splice(i, 1);
			},  
            saveItem() {
				this.isLoading = true;
				var data = this.item;
				data.totals = this.getTotals;
				this.$http.post( process.env.VUE_APP_API_URL + "/recipes/wetend/save", data).then(response => {  
					if(response.body.success){
						this.actionDialogShow = true;
						this.actionDialogText = "Kayıt başarılı"
						this.actionDialogColor = "green"
						this.$router.replace("/recipes/wetend/edit/?id="+response.body.id)
						setTimeout(()=>{
							location.reload();
						},500)
					}
					else{
						this.actionDialogShow = true;
						this.actionDialogText = response.body.reason
						this.actionDialogColor = "red" 
						this.isLoading = false;
					} 
				}) 
			}, 
			
			calcMiktar(i){
				var agirlik = parseFloat(this.item.agirlik || 0) || 0
				var yuzde = parseFloat(this.item.entries[i].yuzde || 0) || 0
				if(agirlik > 0 && yuzde > 0){
					this.item.entries[i].miktar = Math.round(agirlik / 100 * yuzde)
				}
			},
			calcMiktarAll(){
				for(var i in this.item.entries){
					this.calcMiktar(i)
				}
			},
        },
        computed: {
            getTotals() {
				var totals = {zaman : 0};
				for(var i in this.item.entries){
					totals.zaman += parseInt(this.item.entries[i].zaman || 0) || 0;
				}
                return totals
            },
			getAuth(){
				return this.$store.getters.getAuth;
			} 
        }
    }
</script>

<style lang="less">
    .RecipesTable { 
		.colFmlt{
			color:rgb(95, 95, 95);
		}
	}
	.RecipesTableWetend{
		margin-bottom: 50px;
		.tblInfo{
			.tdlLabel{ 
				padding: 4px;  
				font-size:13px;
				font-weight: 700;
			}
		}
		.tblHeads{
			td{
				font-size:11px;
				line-height: 12px;
				text-align: center;
				padding: 10px 0px;
				b{
					display: block;
					text-align: center;
				}
			}
		}
		.tblTotal{
			td{
				&:first-child{
					border-left: none;
				}
				padding: 4px; 
				line-height: 24px;
				font-size:14px;
			}
		} 
		.tblMechanic{
			td{ 
				padding: 4px; 
				line-height: 24px;
				font-size:14px;
			}
		} 
	}
</style>